import { http } from "./http";
import { GET_ALL_WOUND_CODE, GET_WOUND_BY_WOUND_KEY, GET_WOUND_CODE_BY_QUERY } from "./URL";

export const getAllWoundCodes = async () => {
    try{
        const response = await http.get(GET_ALL_WOUND_CODE);
        return response;
    } catch(error) {
        throw error;
    }
    
};

export const getWoundCodesByQueries = async (searchQuery: string, woundType: string, headers: Record<string, string>) => {
    try{
        const params = new URLSearchParams({
            searchQuery: searchQuery,
            woundType: woundType
        });
        const response = await http.get(`${GET_WOUND_CODE_BY_QUERY}?${params.toString()}`, {
            headers: {
                ...headers,
            },
        });
        return response;
    } catch(error) {
        throw error;
    }
    
};

export const getWoundInfoByWoundKey = async (woundKey: string, woundType: string) => {
    try{
        // CS-1984: build the query via URLSearchParams (encodes special chars; coerces undefined → "" instead of
        // the literal "undefined"), matching the sibling getWoundCodesByQueries. Raw concat below was unsafe.
        // let queryParam = "";
        // queryParam += `?woundKey=${woundKey}&`;
        // queryParam += `woundType=${woundType}`;
        // const response = await http.get(GET_WOUND_BY_WOUND_KEY + queryParam);
        const params = new URLSearchParams({ woundKey: woundKey ?? "", woundType: woundType ?? "" });  // CS-1984
        const response = await http.get(`${GET_WOUND_BY_WOUND_KEY}?${params.toString()}`);             // CS-1984
        return response;
    } catch(error) {
        throw error;
    }
    
};
